import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// 按需导入页面组件
import IndexPage from '@/views/index/index.vue'
import LoginPage from '@/views/login/login.vue'
import CompanyManage from '@/views/company/CompanyManage.vue'
import AccountManage from '@/views/company/AccountManage.vue'
import AccountRecordDetail from '@/views/company/AccountRecordDetail.vue'
import FlightOrderList from '@/views/order/FlightOrderList.vue'
import HotelOrderList from '@/views/order/HotelOrderList.vue'
import TrainOrderList from '@/views/order/TrainOrderList.vue'
import MeituanOrderList from '@/views/order/MeituanOrderList.vue'
import JingdongOrderList from '@/views/order/JingdongOrderList.vue'
// import OtherOrderList from '@/views/order/OtherOrderList.vue' // 隐藏其他订单页面
// 系统管理相关页面
import UserManage from '@/views/system/UserManage.vue'
import RoleManage from '@/views/system/RoleManage.vue'
import MenuManage from '@/views/system/MenuManage.vue'

const routes = [
  { path: '/', redirect: '/login' },
  { path: '/index', name: 'Index', component: IndexPage },
  { path: '/login', name: 'Login', component: LoginPage },
  { path: '/company', name: 'CompanyManage', component: CompanyManage },
  { path: '/account', name: 'AccountManage', component: AccountManage },
  { path: '/account/record', name: 'AccountRecordDetail', component: AccountRecordDetail },
  // 订单相关路由
  { path: '/order/flight', name: 'FlightOrderList', component: FlightOrderList },
  { path: '/order/hotel', name: 'HotelOrderList', component: HotelOrderList },
  { path: '/order/train', name: 'TrainOrderList', component: TrainOrderList },
  { path: '/order/meituan', name: 'MeituanOrderList', component: MeituanOrderList },
  { path: '/order/jingdong', name: 'JingdongOrderList', component: JingdongOrderList },
  // 系统管理相关路由
  { path: '/system/user', name: 'UserManage', component: UserManage },
  { path: '/system/role', name: 'RoleManage', component: RoleManage },
  { path: '/system/menu', name: 'MenuManage', component: MenuManage },
  // 未匹配路由重定向到登录页
  { path: '*', redirect: '/login' }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

// 全局导航守卫
router.beforeEach((to, from, next) => {
  // 不需要登录的页面（登录页）
  const noAuthPages = ['/login']

  // 如果访问的页面不需要认证，直接放行
  if (noAuthPages.includes(to.path)) {
    next()
    return
  }

  // 判断是否已登录（有token）
  const token = localStorage.getItem('token')
  if (!token) {
    // 未登录，重定向到登录页
    next('/login')
  } else {
    // 已登录，放行
    next()
  }
})

export default router
